import React, { useState } from 'react';
import { DeleteOutlined, EyeOutlined, FolderOpenOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Card, Flex, Image, Popconfirm, Spin, Typography, Upload } from 'antd';

const { Text } = Typography;

const TILE_SIZE = 156;

const ImagePickerDesktop = ({ viewModel }) => {
    const {
        loading,
        previewSrc,
        hasValue,
        acceptValue,
        uploadRef,
        handleUpload,
        handlePreview,
        handleRemove,
        openLibrary,
    } = viewModel;

    const [hovered, setHovered] = useState(false);

    return (
        <div style={{ width: TILE_SIZE }}>
            <Card
                hoverable
                size='small'
                styles={{ body: { display: 'none' } }}
                style={{ width: TILE_SIZE, overflow: 'hidden' }}
                cover={
                    <div
                        style={{ position: 'relative', aspectRatio: '1 / 1', overflow: 'hidden', cursor: 'pointer' }}
                        onMouseEnter={() => setHovered(true)}
                        onMouseLeave={() => setHovered(false)}
                    >
                        {previewSrc ? (
                            <Image
                                preview={false}
                                src={previewSrc}
                                alt='image'
                                fallback='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='
                                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                            />
                        ) : (
                            <Flex vertical align='center' justify='center' gap={8} style={{ position: 'absolute', inset: 0 }}>
                                <Button type='primary' shape='circle' size='large' loading={loading} icon={loading ? undefined : <PlusOutlined />} />
                                <Text type='secondary' style={{ fontSize: 12 }}>Chọn ảnh</Text>
                            </Flex>
                        )}

                        {hovered && hasValue && (
                            <Flex
                                gap={6}
                                wrap
                                align='center'
                                justify='center'
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    background: 'rgba(0,0,0,0.45)',
                                    padding: 8,
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {previewSrc ? <Button type='primary' shape='circle' size='middle' icon={<EyeOutlined />} title='Xem' onClick={handlePreview} /> : null}

                                <Upload showUploadList={false} accept={acceptValue} beforeUpload={handleUpload} disabled={loading}>
                                    <Button type='primary' shape='circle' size='middle' loading={loading} icon={loading ? undefined : <UploadOutlined />} title='Thay ảnh' />
                                </Upload>

                                <Button shape='circle' size='middle' icon={<FolderOpenOutlined />} title='Thư viện' onClick={openLibrary} />

                                <Popconfirm title='Xóa ảnh này?' onConfirm={handleRemove} okText='Xóa' cancelText='Hủy'>
                                    <Button danger shape='circle' size='middle' icon={<DeleteOutlined />} title='Xóa' onClick={(e) => e.stopPropagation()} />
                                </Popconfirm>
                            </Flex>
                        )}

                        {hovered && !hasValue && (
                            <Flex
                                gap={8}
                                align='center'
                                justify='center'
                                style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.1)' }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Upload showUploadList={false} accept={acceptValue} beforeUpload={handleUpload} disabled={loading}>
                                    <Button type='primary' shape='circle' size='large' loading={loading} icon={loading ? undefined : <UploadOutlined />} title='Tải ảnh lên' />
                                </Upload>

                                <Button shape='circle' size='large' icon={<FolderOpenOutlined />} title='Thư viện' onClick={openLibrary} />
                            </Flex>
                        )}

                        {loading && (
                            <Flex align='center' justify='center' style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.7)' }}>
                                <Spin />
                            </Flex>
                        )}
                    </div>
                }
            />

            {/* Hidden Upload for ref-based trigger */}
            <div ref={uploadRef} style={{ display: 'none' }}>
                <Upload showUploadList={false} accept={acceptValue} beforeUpload={handleUpload} disabled={loading}>
                    <span />
                </Upload>
            </div>
        </div>
    );
};

export default ImagePickerDesktop;
